var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          {
            staticClass:
              "tickets-page--template page-template overflow-x-hidden",
          },
          [
            _c(
              "h1",
              {
                staticClass:
                  "f1 mv0 h1 page-title lh-title mv0 lh-solid tl ttu is-blenny is-black",
                staticStyle: { color: "transparent", height: "0px" },
              },
              [_vm._v("\n        Tickets\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "relative z-content bg-beige" }, [
              _c("div", { staticClass: "relative container-fluid" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "relative pv4 container-fluid z-content" },
                [
                  _vm.page.three_day_section.is_published
                    ? _c(
                        "section",
                        {
                          staticClass:
                            "relative mw9 center mt4 mt0-ns pt2 pb3 pv4-ns",
                          attrs: { id: _vm.page.three_day_section.slug },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex relative mb2 mb3-ns tl flex-row items-center",
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "f-page-hdr mv0 ttu is-blenny is-navy",
                                  attrs: {
                                    id: _vm.page.three_day_section.slug,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.page.three_day_section.title) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(
                              _vm.page.three_day_section.tickets,
                              function (ticket, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "tix-column-" + index,
                                    staticClass:
                                      "relative col-xs-12 col-sm-6 col-md-4 mb4",
                                    attrs: { id: ticket.slug },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "relative pt1 pb0 ph3 ph3-ns",
                                        class: {
                                          "bg-yellow border-yellow":
                                            index === 2,
                                          "bg-teal border-teal": index !== 2,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "relative flex flex-row justify-between mv3",
                                            class: { "": index === 2 },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative tl mw5 flex items-center w-50",
                                                class: {
                                                  "w-col-lg-important":
                                                    index === 2,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "db w5",
                                                    class: {
                                                      "w-col-lg-important":
                                                        index === 2,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "db w-100 f3 ttu is-tablet-regular",
                                                        class: {
                                                          "is-navy":
                                                            index === 2,
                                                          "is-beige":
                                                            index !== 2,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              ticket.title
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    ticket.sub_title
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "db f4 mt2 is-tablet-regular",
                                                            class: {
                                                              "is-navy":
                                                                index === 2,
                                                              "is-beige":
                                                                index !== 2,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                ticket.sub_title
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative tr w-100",
                                                class: {
                                                  "dn-important": index === 2,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "f2 is-tablet-bold ttu is-beige",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(ticket.price)
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "db ttu f5 is-tablet-regular",
                                                      },
                                                      [_vm._v(" +fees")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "relative mv3 tc" },
                                          [
                                            ticket.is_disabled
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      target: "_blank",
                                                      title:
                                                        ticket.title +
                                                        " On Sale 3/15",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : ticket.is_sold_out
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      target: "_blank",
                                                      title:
                                                        ticket.title +
                                                        " Sold Out",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer",
                                                    attrs: {
                                                      href: ticket.link,
                                                      target: "_blank",
                                                      title: ticket.title,
                                                      id: ticket.id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        ticket.button_two.is_external_link
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative mt3 mb3 tc",
                                              },
                                              [
                                                ticket.button_two.is_disabled
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                        attrs: {
                                                          target: "_blank",
                                                          title:
                                                            ticket.button_two
                                                              .title +
                                                            " On Sale 3/15",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  ticket
                                                                    .button_two
                                                                    .text
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : ticket.button_two
                                                      .is_sold_out
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                        attrs: {
                                                          target: "_blank",
                                                          title:
                                                            ticket.button_two
                                                              .title +
                                                            " Sold Out",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  ticket
                                                                    .button_two
                                                                    .text
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer",
                                                        attrs: {
                                                          href: ticket
                                                            .button_two.link,
                                                          target: "_blank",
                                                          title:
                                                            ticket.button_two
                                                              .title,
                                                          id: ticket.id,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  ticket
                                                                    .button_two
                                                                    .text
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "relative mv3 tc",
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer",
                                                    attrs: {
                                                      title:
                                                        ticket.button_two
                                                          .title +
                                                        " On Sale 3/15",
                                                      to: ticket.button_two
                                                        .link,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_two
                                                                .text
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                        _vm._v(" "),
                                        ticket.messaging_text
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "db relative mv4 tl",
                                              },
                                              [
                                                ticket.messaging_text
                                                  ? _c("div", {
                                                      staticClass:
                                                        "f3 is-bureau-bold is-beige cms-content",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.marked(
                                                            ticket.messaging_text
                                                          )
                                                        ),
                                                      },
                                                    })
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "f3 is-bureau-bold is-beige cms-content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              ticket.messaging_text
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "relative pb0 pb3 ph3 ph3-ns bg-beige",
                                        class: {
                                          "border-yellow": index === 2,
                                          "border-teal": index !== 2,
                                        },
                                      },
                                      [
                                        ticket.perks.is_published
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative mv3 mv4-ns tl is-tablet-regular is-black",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "f5 mt2 mb3 tl is-tablet-bold is-navy",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      ticket.perks.text
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "db" },
                                                  [
                                                    index === -1
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-teal",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "is-table-bold b ttu is-teal",
                                                                attrs: {
                                                                  title:
                                                                    "More perks",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "More Details Coming Soon!"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "perks-dropdown",
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "perks-content",
                                                              },
                                                              _vm._l(
                                                                ticket.perks
                                                                  .perks_list,
                                                                function (
                                                                  perk,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        "ticket-perks-" +
                                                                        index,
                                                                      staticClass:
                                                                        "relative flex flex-row items-center f5 mv1 pv1",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "relative mr4 w4 check-container",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "w-100",
                                                                              attrs:
                                                                                {
                                                                                  src: perk.image,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "w-100",
                                                                        },
                                                                        [
                                                                          perk
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mv0 f5",
                                                                                  domProps:
                                                                                    {
                                                                                      innerHTML:
                                                                                        _vm._s(
                                                                                          perk.copy
                                                                                        ),
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mv0 f5",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      perk.copy
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.page.single_day_section.is_published
                    ? _c(
                        "section",
                        {
                          staticClass: "relative mw9 center pt2 pb3 pv4-ns",
                          attrs: { id: _vm.page.single_day_section.slug },
                        },
                        [
                          _c("div", { staticClass: "relative mb2 mb3-ns tl" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "f-page-hdr mv0 ttu is-blenny is-navy",
                                attrs: { id: _vm.page.single_day_section.slug },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.page.single_day_section.title) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(
                              _vm.page.single_day_section.tickets,
                              function (ticket, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "tix-column-" + index,
                                    staticClass:
                                      "relative col-xs-12 col-sm-6 col-md-4 mb4",
                                    attrs: { id: ticket.slug },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "relative pt1 pb0 ph3 ph3-ns",
                                        class: {
                                          "bg-yellow border-yellow":
                                            index === 2,
                                          "bg-teal border-teal": index !== 2,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "relative flex flex-row justify-between mv3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative tl mw5 flex items-center w-50",
                                                class: {
                                                  "w-col-lg-important":
                                                    index === 2,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "db w5",
                                                    class: {
                                                      "w-col-lg-important":
                                                        index === 2,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "db w-100 f3 ttu is-tablet-regular",
                                                        class: {
                                                          "is-navy":
                                                            index === 2,
                                                          "is-beige":
                                                            index !== 2,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              ticket.title
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    ticket.sub_title
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "db f4 mt2 is-tablet-regular",
                                                            class: {
                                                              "is-navy":
                                                                index === 2,
                                                              "is-beige":
                                                                index !== 2,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                ticket.sub_title
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative tr w-100",
                                                class: {
                                                  "dn-important": index === 2,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "f2 is-tablet-bold ttu is-beige",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(ticket.price)
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "db ttu f5 is-tablet-regular",
                                                      },
                                                      [_vm._v(" +fees")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "relative mv3 tc" },
                                          [
                                            ticket.is_disabled
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      target: "_blank",
                                                      title: ticket.title,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : ticket.is_sold_out
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      target: "_blank",
                                                      title:
                                                        ticket.title +
                                                        " Sold Out",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer",
                                                    attrs: {
                                                      href: ticket.link,
                                                      target: "_blank",
                                                      title: ticket.title,
                                                      id: ticket.id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        index === 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative mt3 mb3 tc",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer",
                                                    attrs: {
                                                      href: ticket.button_two
                                                        .link,
                                                      title:
                                                        ticket.button_two.title,
                                                      id: ticket.id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              ticket.button_two
                                                                .text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        ticket.messaging_text
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "relative mv4 tl",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "f3 is-bureau-bold is-beige",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          ticket.messaging_text
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "relative pb0 pb3 ph3 ph3-ns bg-beige",
                                        class: {
                                          "border-yellow": index === 2,
                                          "border-teal": index !== 2,
                                        },
                                      },
                                      [
                                        ticket.perks.is_published
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative mv3 mv4-ns tl is-tablet-regular is-black",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "f5 mt2 mb3 tl is-tablet-bold is-navy",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      ticket.perks.text
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "db" },
                                                  [
                                                    _c(
                                                      "perks-dropdown",
                                                      [
                                                        _c(
                                                          "template",
                                                          {
                                                            slot: "perks-content",
                                                          },
                                                          _vm._l(
                                                            ticket.perks
                                                              .perks_list,
                                                            function (
                                                              perk,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "perk-" +
                                                                    perk +
                                                                    "-" +
                                                                    index,
                                                                  staticClass:
                                                                    "flex flex-row items-center f5 mv4",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "relative mr4 w4 check-container",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "w-100",
                                                                          attrs:
                                                                            {
                                                                              src: perk.image,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "w-100",
                                                                    },
                                                                    [
                                                                      perk
                                                                        ? _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mv0 f5",
                                                                              domProps:
                                                                                {
                                                                                  innerHTML:
                                                                                    _vm._s(
                                                                                      perk.copy
                                                                                    ),
                                                                                },
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mv0 f5",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  perk.copy
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.page.shuttles_section.is_published
                    ? _c(
                        "section",
                        {
                          staticClass: "relative mw9 center pt2 pb3 pv4-ns",
                          attrs: { id: _vm.page.shuttles_section.slug },
                        },
                        [
                          _c("div", { staticClass: "relative mb2 mb3-ns tl" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "f-page-hdr mv0 ttu is-blenny is-navy",
                                attrs: { id: _vm.page.shuttles_section.slug },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.page.shuttles_section.title) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(
                              _vm.page.shuttles_section.content,
                              function (ticket, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "tix-column-" + index,
                                    staticClass:
                                      "relative col-xs-12 col-sm-6 mb4",
                                    attrs: { id: ticket.slug },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "relative pt1 pb0 ph3 ph3-ns bg-teal border-teal",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "relative flex flex-row justify-between mv3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative tl mw5 flex items-center w-50",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "db w5" },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "db w-100 f3 ttu is-tablet-regular is-beige",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              ticket.title
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative tr w-100",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "f2 is-tablet-bold ttu is-beige",
                                                  },
                                                  [
                                                    index === 1
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "db ttu f6 is-tablet-regular",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " starting at"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(
                                                      _vm._s(ticket.price)
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "db ttu f5 is-tablet-regular",
                                                      },
                                                      [_vm._v(" +fees")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "relative mv3 tc" },
                                          [
                                            ticket.is_disabled
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      target: "_blank",
                                                      title:
                                                        ticket.title +
                                                        " On Sale 3/15",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : ticket.is_sold_out
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      target: "_blank",
                                                      title:
                                                        ticket.title +
                                                        " Sold Out",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer",
                                                    attrs: {
                                                      href: ticket.link,
                                                      target: "_blank",
                                                      title: ticket.title,
                                                      id: ticket.id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              ticket.button_copy
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        ticket.messaging_text
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "relative mv4 tl",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "f3 is-bureau-bold is-beige",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          ticket.messaging_text
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "relative pb0 pb3 ph3 ph3-ns bg-beige border-teal",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "relative mv3 mv4-ns tl is-tablet-regular",
                                          },
                                          [
                                            ticket.first_text
                                              ? _c("div", {
                                                  staticClass:
                                                    "f5 mt2 mb3 tl is-tablet-bold is-navy cms-content",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.marked(
                                                        ticket.first_text
                                                      )
                                                    ),
                                                  },
                                                })
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "f4 mt2 mb3 tl ttu is-tablet-bold is-navy cms-content",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          ticket.first_text
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "tix-info-dropdown",
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "info-content" },
                                                  [
                                                    ticket.second_text
                                                      ? _c("div", {
                                                          staticClass:
                                                            "f5 mt2 mb3 tl is-tablet-bold is-black cms-content",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.marked(
                                                                ticket.second_text
                                                              )
                                                            ),
                                                          },
                                                        })
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "f4 mt2 mb3 tl ttu is-tablet-bold is-black cms-content",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ticket.second_text
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.page.fixed_bg_section.is_published
              ? _c(
                  "fixedbg",
                  { attrs: { background: _vm.page.fixed_bg_section.image } },
                  [
                    _c(
                      "template",
                      { slot: "contents" },
                      [
                        _c(
                          "accolades-static",
                          [
                            _c("template", { slot: "fixed-bg-contents" }, [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.page.fixed_bg_section.text
                                  ),
                                },
                              }),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }